import { ChangeDetectionStrategy, Component, input, computed } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { ChartDataset, ChartOptions, Plugin } from 'chart.js';
import { legendHighlightPlugin, legendOnHover, legendOnLeave } from '../../plugins/legend-highlight.plugin';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  standalone: true,
  imports: [BaseChartDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BarChartComponent {
  labels = input.required<string[]>();
  datasets = input.required<ChartDataset<'bar'>[]>();
  xAxisLabel = input<string>('');
  yAxisLabel = input<string>('');
  showLegend = input<boolean>(true);

  chartPlugins: Plugin[] = [legendHighlightPlugin];

  chartOptions = computed<ChartOptions<'bar'>>(() => ({
    responsive: true,
    maintainAspectRatio: false,
    animation: { duration: 500 },
    plugins: {
      legend: {
        display: this.showLegend(),
        position: 'bottom',
        onHover: legendOnHover,
        onLeave: legendOnLeave,
      },
    },
    scales: {
      x: {
        title: {
          display: !!this.xAxisLabel(),
          text: this.xAxisLabel(),
        },
      },
      y: {
        title: {
          display: !!this.yAxisLabel(),
          text: this.yAxisLabel(),
        },
        beginAtZero: true,
      },
    },
  }));
}
